import {
  ArrowRight,
  MessageCircle,
  Bot,
  Users,
  Zap,
  Globe,
  Clock,
} from "lucide-react";
import { Link } from "react-router-dom";

export default function AiSupportSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-700 via-purple-700 to-indigo-700 text-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[20%] right-[10%] w-72 h-72 rounded-full bg-gradient-to-r from-purple-400 to-pink-400 opacity-20 blur-3xl"></div>
        <div className="absolute bottom-[10%] left-[10%] w-80 h-80 rounded-full bg-gradient-to-r from-blue-400 to-indigo-400 opacity-20 blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/10 text-white mb-6 backdrop-blur-sm">
            <Bot className="w-4 h-4 mr-2" />
            <span className="text-sm font-medium">KI-gestützter Support</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            JUHUU Buddy - Ihr intelligenter Assistent
          </h2>
          <p className="text-xl text-purple-100 max-w-3xl mx-auto">
            Rund um die Uhr Support für Bürger und Verwaltungsmitarbeiter mit
            unserem KI-gestützten Assistenten
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="relative">
            <div className="absolute -top-10 -left-10 w-40 h-40 bg-gradient-to-br from-purple-400 to-pink-400 rounded-full opacity-30 blur-3xl"></div>
            <div className="bg-gradient-to-br from-purple-800 to-indigo-800 rounded-2xl p-6 shadow-2xl border border-white/10 relative z-10">
              <div className="flex items-center mb-4 border-b border-white/10 pb-4">
                <div className="h-10 w-10 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center mr-3">
                  <Bot className="h-5 w-5 text-white" />
                </div>
                <div>
                  <h3 className="font-medium text-white">JUHUU Buddy</h3>
                  <p className="text-xs text-purple-200">Online</p>
                </div>
              </div>

              <div className="space-y-4 mb-6">
                <div className="flex items-start">
                  <div className="flex-shrink-0 h-8 w-8 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center mr-2">
                    <Bot className="h-4 w-4 text-white" />
                  </div>
                  <div className="bg-white/10 rounded-lg rounded-tl-none p-3 max-w-[80%]">
                    <p className="text-sm text-white">
                      Hallo! Ich bin JUHUU Buddy, Ihr KI-Assistent für alle
                      Fragen rund um BikeParking. Wie kann ich Ihnen heute
                      helfen?
                    </p>
                  </div>
                </div>

                <div className="flex items-start justify-end">
                  <div className="bg-white/20 rounded-lg rounded-tr-none p-3 max-w-[80%]">
                    <p className="text-sm text-white">
                      Ich möchte wissen, wie ich einen defekten Fahrradständer
                      melden kann.
                    </p>
                  </div>
                  <div className="flex-shrink-0 h-8 w-8 rounded-full bg-white/20 flex items-center justify-center ml-2">
                    <Users className="h-4 w-4 text-white" />
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0 h-8 w-8 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center mr-2">
                    <Bot className="h-4 w-4 text-white" />
                  </div>
                  <div className="bg-white/10 rounded-lg rounded-tl-none p-3 max-w-[80%]">
                    <p className="text-sm text-white">
                      Sie können defekte Fahrradständer direkt über die JUHUU
                      App melden. Öffnen Sie die App, wählen Sie den betroffenen
                      Standort und tippen Sie auf "Problem melden". Alternativ
                      können Sie auch den QR-Code am Standort scannen und das
                      Problem über die WebApp melden.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-bold mb-6">
              24/7 KI-gestützter Support
            </h3>
            <p className="text-purple-100 mb-8">
              JUHUU Buddy ist ein KI-Chatbot, der auf Ihrer gesamten
              Dokumentation trainiert wurde. Er ist in App, Web und Dashboard
              integriert und beantwortet Fragen, führt einfache Aufgaben aus und
              leitet bei Bedarf an menschlichen Support weiter.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white/10 backdrop-blur-sm p-5 rounded-xl">
                <div className="h-10 w-10 mb-3 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center">
                  <Globe className="h-5 w-5 text-white" />
                </div>
                <h4 className="font-medium text-white mb-2">
                  Überall verfügbar
                </h4>
                <p className="text-sm text-purple-200">
                  Integriert in App, WebApp und Dashboard für nahtlosen Support
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm p-5 rounded-xl">
                <div className="h-10 w-10 mb-3 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center">
                  <Clock className="h-5 w-5 text-white" />
                </div>
                <h4 className="font-medium text-white mb-2">
                  24/7 Verfügbarkeit
                </h4>
                <p className="text-sm text-purple-200">
                  Rund um die Uhr Support ohne Wartezeiten für Ihre Nutzer
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm p-5 rounded-xl">
                <div className="h-10 w-10 mb-3 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center">
                  <Zap className="h-5 w-5 text-white" />
                </div>
                <h4 className="font-medium text-white mb-2">
                  Automatisierte Aufgaben
                </h4>
                <p className="text-sm text-purple-200">
                  Führt einfache Aufgaben wie Standortsuche oder Statusabfragen
                  aus
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm p-5 rounded-xl">
                <div className="h-10 w-10 mb-3 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center">
                  <MessageCircle className="h-5 w-5 text-white" />
                </div>
                <h4 className="font-medium text-white mb-2">Mehrsprachig</h4>
                <p className="text-sm text-purple-200">
                  Unterstützt mehrere Sprachen für internationale Besucher
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/ai-support"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-purple-900 bg-white hover:bg-purple-50 transition-colors shadow-lg"
              >
                Mehr über KI-Support erfahren
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
              <Link
                to="/demo"
                className="inline-flex items-center justify-center px-6 py-3 border border-white text-base font-medium rounded-md text-white hover:bg-white/10 transition-colors"
              >
                Demo anfordern
              </Link>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
            <div className="text-3xl font-bold text-white mb-2">90%</div>
            <p className="text-purple-200">
              der Anfragen automatisch beantwortet
            </p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
            <div className="text-3xl font-bold text-white mb-2">24/7</div>
            <p className="text-purple-200">Verfügbarkeit ohne Wartezeiten</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
            <div className="text-3xl font-bold text-white mb-2">-60%</div>
            <p className="text-purple-200">Reduzierung der Support-Kosten</p>
          </div>
        </div>
      </div>
    </section>
  );
}
